import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { IUserGroup } from "@/interfaces/userGroup.interface";

interface UserState {
  token: string | null;
  refreshToken: string | null;
  user: UserInterface | null;
  userGroups: IUserGroup[];
}

interface UserInterface {
  displayName: string;
  principalName: string;
  idProvider: string;
  passwordSalt: string;
  passwordHash: string;
  lastLoginDate: string;
  modifiedBy: number;
  modifiedOn: string;
  id: string;
  isDeleted: boolean;
  roles: string[];
}

interface AuthResponseInterface {
  token: string;
  refreshToken: string;
  user: UserInterface;
}

const initialState: UserState = {
  token: null,
  refreshToken: null,
  user: null,
  userGroups: [],
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AuthResponseInterface>) => {
      localStorage.setItem("atToken", action.payload.token);
      localStorage.setItem("rtToken", action.payload.refreshToken);
      localStorage.setItem("user", JSON.stringify(action.payload.user));

      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.user = action.payload.user;
    },
    clearUser: (state) => {
      localStorage.removeItem("atToken");
      localStorage.removeItem("rtToken");
      localStorage.removeItem("user");

      state.token = null;
      state.refreshToken = null;
      state.user = null;
      state.userGroups = [];
    },
    setUserGroups: (state, action: PayloadAction<IUserGroup[]>) => {
      state.userGroups = action.payload;
    },
  },
});

export const { setUser, clearUser, setUserGroups } = userSlice.actions;

export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
